import React from 'react';
import Header from '../components/Header';
import Section from '../components/Section';
import ScheduleTableContainer from '../containers/ScheduleTable.container';
import MaterialContainer from '../containers/Materials.container';
import MedalContainer from '../containers/MedalTable.container';

const Schedule = () => (
    <React.Fragment>
        <Header mod={'page__header_kalendar'} />
        <Section
            title="Расписание"
            mod="section_colored"
        >
            <ScheduleTableContainer />
        </Section>
        <Section
            title="Материалы"
            button={{ href: '/olympic2018/materials#', text: 'Все материалы' }}
        >
            <MaterialContainer mlimits={7} nlimits={8} />
        </Section>
        <Section title="Медальный зачет" mod={'colored'} button={{ href: '/olympic2018/medalnyj-zachet-olimpiada-2018#', text: 'Весь медальный зачет' }}>
            <MedalContainer limits={5} />
        </Section>
    </React.Fragment>
);

export default Schedule;



// WEBPACK FOOTER //
// ./src/pages/Schedule.jsx